import { transRegion } from '@op/utils';

export const countryList = [
  'de',
  'es',
  'fr',
  'gb',
  'it',
  'nl',
  'pl',
  'tr',
  'id',
  'jp',
  'kr',
  'my',
  'ph',
  'pk',
  'sg',
  'th',
  'vn',
  'ae',
  'qa',
  'sa',
  'ar',
  'br',
  'ca',
  'co',
  'mx',
  'us',
  'au',
  'nz',
  'eg',
  'ng',
];

export const countryOptions = countryList.map(item => {
  return {
    text: transRegion(item, 2),
    textCn: transRegion(item, 4),
    value: item,
  };
});

export const allCountryMap = {
  allText: 'All Countries',
  allTextCn: '全部国家',
};
